module.exports = __webpack_public_path__ + "img/flecha_down.62e3c5e1.svg";